import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../pages-styles/project-consultancy.css';
import { usePageMeta } from '../hooks/usePageMeta';

// Material Design Icons
import AssignmentIcon from '@mui/icons-material/Assignment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MapIcon from '@mui/icons-material/Map';
import ComputerIcon from '@mui/icons-material/Computer';
import CodeIcon from '@mui/icons-material/Code';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PolicyIcon from '@mui/icons-material/Policy';
import SecurityIcon from '@mui/icons-material/Security';
import GavelIcon from '@mui/icons-material/Gavel';

function ProjectConsultancy() {
  usePageMeta(
    'Project Consultancy - Professional Services',
    'Web Development, App Development, and Graphic Design services.'
  );

  const services = [
    {
      id: 1,
      title: 'Project Consultancy & Advisory',
      icon: AssignmentIcon,
      description: 'Strategic consultancy services including project planning, advisory support, feasibility analysis, and strategic guidance.',
      link: '/project-consultancy/advisory'
    },
    {
      id: 2,
      title: 'Market Research & Feasibility Studies',
      icon: TrendingUpIcon,
      description: 'Market and industry analysis, demand assessment, data-driven insights, and strategic recommendations.',
      link: '/project-consultancy/market-research'
    },
    {
      id: 3,
      title: 'Project Planning & Development Support',
      icon: MapIcon,
      description: 'Project roadmap planning, operational frameworks, monitoring and evaluation support.',
      link: '/project-consultancy/planning'
    },
    {
      id: 4,
      title: 'ICT & Digital Project Consultancy',
      icon: ComputerIcon,
      description: 'Digital transformation advisory, ICT project planning, system design guidance.',
      link: '/project-consultancy/ict'
    },
    {
      id: 5,
      title: 'Web, Application & System Development',
      icon: CodeIcon,
      description: 'Consultancy-led web and application development, UI/UX advisory, technical coordination.',
      link: '/project-consultancy/development'
    },
    {
      id: 6,
      title: 'Client Responsibilities',
      icon: VerifiedUserIcon,
      description: 'Understanding client obligations including information provision, timely feedback, and compliance.',
      link: '/project-consultancy/client-responsibilities'
    },
    {
      id: 7,
      title: 'No Guarantees Clause',
      icon: PolicyIcon,
      description: 'Consultancy services do not guarantee financial returns, funding, or project success.',
      link: '/project-consultancy/guarantees'
    },
    {
      id: 8,
      title: 'Separation From Football Agency',
      icon: SecurityIcon,
      description: 'Project consultancy services are entirely independent from football agency services.',
      link: '/project-consultancy/separation'
    },
    {
      id: 9,
      title: 'Discretion & Service Limitation',
      icon: GavelIcon,
      description: 'Magbity Agency reserves the right to decline. These are notes which users must take note of - they are not part of the services.',
      link: '/project-consultancy/discretion'
    }
  ];

  return (
    <div className="project-consultancy">
      <section className="consultancy-hero-banner">
        <div className="consultancy-hero-overlay"></div>
        <div className="consultancy-hero-content">
          <img 
            src="https://i.pinimg.com/736x/14/60/54/1460544c14e26b1bd102e6ff01308af4.jpg" 
            alt="Project Consultancy" 
            className="consultancy-hero-image"
          />
          <div className="consultancy-hero-text">
            <h1>Project Consultancy Services</h1>
            <p>Professional consultation and expert guidance for your digital and creative projects</p>
          </div>
        </div>
      </section>

      <section className="consultancy-services">
        <h2>Our Consultancy Services</h2>
        <div className="services-list">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            const isEven = index % 2 === 0;
            
            return (
              <div key={service.id} className={`service-item ${isEven ? 'left' : 'right'}`}>
                <div className="service-icon-wrapper">
                  <IconComponent className="service-icon-large" />
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <Link to={service.link} className="read-more-btn">
                    Read More
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="services-section">
      </section>
    </div>
  );
}

export default ProjectConsultancy;
